export class OTPLaterLabel_EN {

    dialog: {
        nameOfApplicant: string;
        dlpRefNumber: string;
        quotation: string;
    }

    button: {
        submit: string;
        resend: string;
        review: string;
    }

    constructor() {

        this.dialog = {
            nameOfApplicant: "Name of Applicant: ",
            dlpRefNumber: " DLP Ref Number ",
            quotation: "Quotation For"
        }
        this.button = {
            submit: "Submit OTP Now",
            resend: "Resend OTP",
            review: "Review"
        }
    }
}